
<div>
  <template v-if="modeIs('select')">
    <field-item
        v-for="variable in handler.getElements()"
        :key="variable.clientIdOrId"
        :disabled="handler.isDisabled(variable)"
        @click="select(handler.selectVariable(variable))"
        class="pt-2 pl-2">
      <row>
        <prefix>
          <icon :glyph="varIOClass(variable)"/>
        </prefix>
        <column>
          {{variable.name}}
        </column>
      </row>
    </field-item>
  </template>
</div>
